import { render, staticRenderFns } from "./orderiklanrevision.vue?vue&type=template&id=671ee896"
import script from "./orderiklanrevision.vue?vue&type=script&lang=js"
export * from "./orderiklanrevision.vue?vue&type=script&lang=js"
import style0 from "./orderiklanrevision.vue?vue&type=style&index=0&id=671ee896&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports